module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_21_3.d44137ca.jpeg";